module.exports = __webpack_public_path__ + "static/img/performance01.b17779c6.jpg";